var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { name: "modal-signup", width: 620 } },
    [
      _vm.activeElem === "login"
        ? _c("login", { attrs: { categoryProps: _vm.categoryProps } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeElem === "register"
        ? _c("register", { attrs: { categoryProps: _vm.categoryProps } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeElem === "forgot-pass"
        ? _c("forgot-pass", { attrs: { categoryProps: _vm.categoryProps } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }